// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataQualityRulesTable } from './data-quality-rules-table';
import {
    DataQualityRulesTableFromJSON,
    DataQualityRulesTableFromJSONTyped,
    DataQualityRulesTableToJSON,
    DataQualityRulesTableToJSONTyped,
} from './data-quality-rules-table';
import type { PiiRule } from './pii-rule';
import {
    PiiRuleFromJSON,
    PiiRuleFromJSONTyped,
    PiiRuleToJSON,
    PiiRuleToJSONTyped,
} from './pii-rule';
import type { DQRule } from './dq-rule';
import {
    DQRuleFromJSON,
    DQRuleFromJSONTyped,
    DQRuleToJSON,
    DQRuleToJSONTyped,
} from './dq-rule';

/**
 * 
 * @export
 * @interface DataQualityRules
 */
export interface DataQualityRules {
    /**
     * 
     * @type {object}
     * @memberof DataQualityRules
     */
    fileMatching?: object;
    /**
     * 
     * @type {PiiRule}
     * @memberof DataQualityRules
     */
    majorPii?: PiiRule;
    /**
     * 
     * @type {Array<DQRule>}
     * @memberof DataQualityRules
     */
    majorRules?: Array<DQRule>;
    /**
     * 
     * @type {PiiRule}
     * @memberof DataQualityRules
     */
    minorPii?: PiiRule;
    /**
     * 
     * @type {Array<DQRule>}
     * @memberof DataQualityRules
     */
    minorRules?: Array<DQRule>;
    /**
     * 
     * @type {object}
     * @memberof DataQualityRules
     */
    preConformance?: object;
    /**
     * 
     * @type {DataQualityRulesTable}
     * @memberof DataQualityRules
     */
    table?: DataQualityRulesTable;
    /**
     * 
     * @type {string}
     * @memberof DataQualityRules
     */
    table_name?: string;
}

/**
 * Check if a given object implements the DataQualityRules interface.
 */
export function instanceOfDataQualityRules(value: object): value is DataQualityRules {
    return true;
}

export function DataQualityRulesFromJSON(json: any): DataQualityRules {
    return DataQualityRulesFromJSONTyped(json, false);
}

export function DataQualityRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataQualityRules {
    if (json == null) {
        return json;
    }
    return {
        
        'fileMatching': json['fileMatching'] == null ? undefined : json['fileMatching'],
        'majorPii': json['majorPii'] == null ? undefined : PiiRuleFromJSON(json['majorPii']),
        'majorRules': json['majorRules'] == null ? undefined : ((json['majorRules'] as Array<any>).map(DQRuleFromJSON)),
        'minorPii': json['minorPii'] == null ? undefined : PiiRuleFromJSON(json['minorPii']),
        'minorRules': json['minorRules'] == null ? undefined : ((json['minorRules'] as Array<any>).map(DQRuleFromJSON)),
        'preConformance': json['preConformance'] == null ? undefined : json['preConformance'],
        'table': json['table'] == null ? undefined : DataQualityRulesTableFromJSON(json['table']),
        'table_name': json['table_name'] == null ? undefined : json['table_name'],
    };
}

export function DataQualityRulesToJSON(json: any): DataQualityRules {
    return DataQualityRulesToJSONTyped(json, false);
}

export function DataQualityRulesToJSONTyped(value?: DataQualityRules | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileMatching': value['fileMatching'],
        'majorPii': PiiRuleToJSON(value['majorPii']),
        'majorRules': value['majorRules'] == null ? undefined : ((value['majorRules'] as Array<any>).map(DQRuleToJSON)),
        'minorPii': PiiRuleToJSON(value['minorPii']),
        'minorRules': value['minorRules'] == null ? undefined : ((value['minorRules'] as Array<any>).map(DQRuleToJSON)),
        'preConformance': value['preConformance'],
        'table': DataQualityRulesTableToJSON(value['table']),
        'table_name': value['table_name'],
    };
}
